import * as React from "react";
import { useOrder, createContainsHelper } from "@grandvisionhq/fun-orders";
import { useCartStorage } from "@grandvisionhq/lib-utils-cart";
import { useLocalStorage } from "@grandvisionhq/lib-utils-w3c";
import { useIntl } from "@grandvisionhq/state";
import { useSessionStorage } from "@grandvisionhq/utils";
import { pushPurchaseEventToDataLayer, trackOrderCompletionEvents } from "../../data-layer.js";
import { SHIPPING_STATE_KEY } from "../../LoginExpressCheckout/models/LoginExpressCheckout/models/shippingTypes.js";
import { USER_DETAILS_STATE_KEY } from "../../LoginExpressCheckout/models/LoginExpressCheckout/models/user-details-types.js";
import { OrderConfirm } from "./OrderConfirm.js";
import { useOrderConfirmTealiumEvent } from "../hooks/OrderConfirmV2/hooks/use-order-confirm-tealium-event.js";
import { useOrderConfirmLabels } from "../hooks/OrderConfirmV2/hooks/use-order-confirm-labels.js";
const OrderConfirmContainerV2 = ({
  logo,
  orderData: orderToken,
  cartId,
  checkoutMethod = "regular_checkout",
  isTrustedShopsCheckout
}) => {
  const [, { reset }] = useCartStorage();
  const { getOrderByToken, order, error, loading } = useOrder();
  const { handleOrderConfirmPageEventDispatch } = useOrderConfirmTealiumEvent();
  const labels = useOrderConfirmLabels(order);
  const { currency } = useIntl();
  const [, , removeShippingState] = useLocalStorage(SHIPPING_STATE_KEY, null);
  const [, , removeUserDetailsState] = useLocalStorage(USER_DETAILS_STATE_KEY, null);
  const [, removeAdyenPaymentConfiguration] = useSessionStorage(
    "payment-configuration",
    void 0,
    (value) => value === void 0
  );
  const contains = React.useMemo(() => createContainsHelper(order?.lineItems), [order?.lineItems]);
  const onCompleted = React.useCallback(() => {
    reset();
    removeShippingState();
    removeUserDetailsState();
    removeAdyenPaymentConfiguration(void 0);
  }, [removeAdyenPaymentConfiguration, removeShippingState, removeUserDetailsState, reset]);
  React.useEffect(() => {
    if (orderToken) {
      getOrderByToken(orderToken, onCompleted);
    }
  }, [orderToken]);
  React.useEffect(() => {
    if (order) {
      if (order.donationIntent && order.donation?.amount) {
        pushPurchaseEventToDataLayer(order, currency, cartId, checkoutMethod, {
          foundationKey: order.donationIntent.foundationKey,
          centAmount: order.donation.amount
        });
      } else {
        pushPurchaseEventToDataLayer(order, currency, cartId, checkoutMethod);
      }
      trackOrderCompletionEvents(order, currency);
      handleOrderConfirmPageEventDispatch(order);
    }
  }, [cartId, currency, order, handleOrderConfirmPageEventDispatch, checkoutMethod]);
  return /* @__PURE__ */ React.createElement(
    OrderConfirm,
    {
      order,
      logo,
      labels,
      contains,
      error,
      isLoading: loading,
      isTrustedShopsCheckout
    }
  );
};
export {
  OrderConfirmContainerV2
};
//# sourceMappingURL=OrderConfirmContainerV2.js.map
